import { Route, Switch } from "react-router-dom";
import React from "react";

import Login from "../pages/login/index";
import LandingPage from "../pages/LandingPage";
import Index from "../pages/admin/index";
import MembersHierarchy from "../pages/admin/components/MembersHierarchy";
import UserProfile from "../pages/admin/components/UserProfile";
import ResourceDelegations from "../pages/admin/components/ResourceDelegations";
import CreateUser from "../pages/login/CreateUser";
import Sso from "../pages/login/sso";
import Logout from "../pages/logout/index";
import AdminSupport from "../pages/admin-support/index";
import Emailverify from "../pages/login/forgotpassword/EmailVerfiyPage";
import OTPValidate from "../pages/login/forgotpassword/OTPValidatePage";
import ChangePasswordForm from "../pages/login/forgotpassword/ChangePasswordPage";

export default function Routes() {
  return (
    <Switch>
      <Route path="/projects">
        <LandingPage />
      </Route>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/EmailVerify">
        <Emailverify />
      </Route>
      <Route path="/OtpValidate">
        <OTPValidate />
      </Route>
      <Route path="/ChangePassword">
        <ChangePasswordForm />
      </Route>
      <Route path="/resource-hierarchy">
        <MembersHierarchy />
      </Route>
      <Route path="/resource-delegations">
        <ResourceDelegations />
      </Route>
      <Route path="/settings">
        <Index />
      </Route>
      <Route path="/user-profile">
        <UserProfile />
      </Route>
      <Route path="/create-user">
        <CreateUser />
      </Route>
      <Route path="/sso">
        <Sso />
      </Route>
      <Route path="/logout">
        <Logout />
      </Route>
      <Route path="/admin-support">
        <AdminSupport />
      </Route>
    </Switch>
  );
}
